import moment from 'moment'

import { IAPIExpensesReport, IExpensesReport } from './IExpensesReport'

class Transformer {
    static transform(report: IAPIExpensesReport): IExpensesReport {
        return {
            amount: report.amount,
            currency: report.currency,
            expendedAt: moment(report.expended_at),
            reason: report.reason_type_name,
        }
    }
}

export default Transformer
